import { useState } from "react";
import { Palette } from "lucide-react";
const backgroundOptions = {
  colors: [{
    id: "default",
    value: "bg-gray-50",
    label: "Default Gray"
  }, {
    id: "blue",
    value: "bg-blue-100",
    label: "Soft Blue"
  }, {
    id: "purple",
    value: "bg-purple-100",
    label: "Soft Purple"
  }, {
    id: "green",
    value: "bg-green-100",
    label: "Soft Green"
  }],
  gradients: [{
    id: "bluePurple",
    value: "bg-gradient-to-br from-blue-100 to-purple-100",
    label: "Blue to Purple"
  }, {
    id: "greenBlue",
    value: "bg-gradient-to-br from-green-100 to-blue-100",
    label: "Green to Blue"
  }, {
    id: "sunsetOrange",
    value: "bg-gradient-to-br from-orange-100 to-red-100",
    label: "Sunset Orange"
  }],
  images: [{
    id: "geometric",
    value: 'bg-[url("https://images.unsplash.com/photo-1553356084-58ef4a67b2a7?auto=format&fit=crop&q=80")] bg-cover bg-fixed bg-center bg-no-repeat bg-opacity-20',
    label: "Geometric Pattern"
  }, {
    id: "abstract",
    value: 'bg-[url("https://images.unsplash.com/photo-1618005198919-d3d4b5a92ead?auto=format&fit=crop&q=80")] bg-cover bg-fixed bg-center bg-no-repeat bg-opacity-20',
    label: "Abstract Pattern"
  }]
};
interface BackgroundSelectorProps {
  onSelect: (background: string) => void;
}
export const BackgroundSelector = ({
  onSelect
}: BackgroundSelectorProps) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="fixed top-4 right-4 z-50">
      <button onClick={() => setIsOpen(!isOpen)} className="inline-flex items-center gap-2 px-3 py-2 bg-white text-gray-600 rounded-lg hover:bg-gray-50 shadow-sm text-sm">
        <Palette size={16} />

      </button>
      {isOpen && <div className="absolute right-0 mt-2 w-64 bg-white rounded-lg shadow-lg p-4 space-y-4">
          <div>
            <h3 className="font-medium mb-2">Solid Colors</h3>
            <div className="space-y-2">
              {backgroundOptions.colors.map(color => <button key={color.id} onClick={() => onSelect(color.value)} className="w-full flex items-center gap-2 px-3 py-2 hover:bg-gray-50 rounded-lg">
                  <div className={`w-6 h-6 rounded ${color.value}`} />
                  <span className="text-sm">{color.label}</span>
                </button>)}
            </div>
          </div>
          <div>
            <h3 className="font-medium mb-2">Gradients</h3>
            <div className="space-y-2">
              {backgroundOptions.gradients.map(gradient => <button key={gradient.id} onClick={() => onSelect(gradient.value)} className="w-full flex items-center gap-2 px-3 py-2 hover:bg-gray-50 rounded-lg">
                  <div className={`w-6 h-6 rounded ${gradient.value}`} />
                  <span className="text-sm">{gradient.label}</span>
                </button>)}
            </div>
          </div>
          <div>
            <h3 className="font-medium mb-2">Image Backgrounds</h3>
            <div className="space-y-2">
              {backgroundOptions.images.map(image => <button key={image.id} onClick={() => onSelect(image.value)} className="w-full text-left px-3 py-2 text-sm rounded hover:bg-gray-50">
                  {image.label}
                </button>)}
            </div>
          </div>
        </div>}
    </div>;
};
